module.exports = __webpack_public_path__ + "img/CALENDER.df66213a.svg";